<template>
    <div class="kplers">
        <v-select v-model="place"
                  taggable
                  :options="options"
                  label="address"
                  @search="onSearch"
                  placeholder="Tìm kiếm và chọn điểm"
        >
            <template slot="no-options">
                Gõ để tìm kiếm điểm...
            </template>
        </v-select>
    </div>

</template>

<script>
    import {RepositoryFactory} from "../services";
    import {MixinHelper} from "../services";
    import debounce from "lodash/debounce"

    const repo = RepositoryFactory.get('regions');
    export default {
        name: "SelectorPlace",
        mixins: [MixinHelper],
        props: {
            value: {
                type: String,
            },
            voyage_id: {
                type: Number,
                default: null,
            },
            order: {
                type: String,
                default: null,
            },
            toText: {
                type: Function,
                default: null,
            },
        },
        created() {
            this.listSuggestPlace('');
        },
        data() {
            return {
                options: [],
            }
        },
        methods: {
            onSearch: debounce(function (search) {
                this.listSuggestPlace(search);
            }, 500),
            listSuggestPlace(search) {
                repo.listSuggestPlace(search, this.voyage_id, this.order)
                    .then(resp => {
                        this.options = this.getProp(resp, 'data.datas', []).map(item => {
                            let option = {};
                            const address = this.toText
                              ? this.toText(item)
                              : this.defaultToText(item);

                            option = {
                                ...option,
                                distance_library_id: this.getProp(item, 'id', 0),
                                address,
                            };
                            return option;
                        });
                    })
                    .catch(err => {
                      // eslint-disable-next-line no-console
                        console.error(err);
                    })
            },
            defaultToText(item) {
              const voyageDistance = item.voyage_distances && item.voyage_distances.find(v => v.voyage_id === this.voyage_id);
              const streetName = this.getProp(item, 'street._name', '');
              const wardName = this.getProp(item, 'ward._name', '');
              const voyageDistanceTime = voyageDistance && voyageDistance.distance_time + (voyageDistance.transit_time ? ' ± ' + voyageDistance.transit_time : '') + 'p';
              return streetName + (wardName ? ` - ${wardName}` : '') + (voyageDistanceTime ? ` (${voyageDistanceTime})` : '');
            },
        },
        computed: {
            place: {
                get() {
                    return this.value;
                },
                set(val) {
                    if (typeof val === 'string') {
                        val = {...{}, address: val};
                    }
                    this.$emit('input', val);
                }
            }
        }
    }
</script>

<style>
    .kplers .v-select {
        border-radius: 4px;
        border: 1px solid #ccc;
    }

    .kplers div {
        left: 20px;
    }

    .kplers input.vs__search {
        padding-left: 15px;
        height: 38px;
        font-size: 14px;
    }

    .kplers .vs__selected {
        padding-left: 15px;
        font-size: 14px;
    }
</style>
